import { Box, Text } from "grommet"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { ItemStatus, ItemType, ProgramItem } from "../components/ProgramItem"
import { MainLayout } from "../components/layout/MainLayout"
import { useMyPapersQuery } from "../generated-types"
import { useNavigate } from "react-router-dom"
import { useLoginContext } from "../components/context/LoginContext"
import { ToastsStore } from "react-toasts"

export type ItemProps = {
  id: string
  type: ItemType
  name: string
  status: ItemStatus
}

export type MyPageProps = {
  items: ItemProps[]
  onAction: (id: string, cmd: string) => void
}

export const MyPage: React.FC<MyPageProps> = ({ items, onAction }) => {
  return (
    <MainLayout>
      <Box fill="horizontal" margin={{ top: "medium", bottom: "large" }} pad="small" gap="small">
        {items.length > 0 ? (
          items.map((v, i) => (
            <ProgramItem key={i} id={v.id} name={v.name} type={v.type} status={v.status} onAction={onAction} />
          ))
        ) : (
          <Text textAlign="center">No Data</Text>
        )}
      </Box>
    </MainLayout>
  )
}

export const MyPageController: React.FC = (props) => {
  const { t } = useTranslation()
  const { loading, data, error } = useMyPapersQuery()
  const { isLogined } = useLoginContext()
  const navigate = useNavigate()
  // if (loading || error) return null
  useEffect(() => {
    if (!isLogined()) {
      ToastsStore.error(t("error.no-auth", "No authentication info"))
      navigate("/", { replace: true })
    }
  }, [])

  const { allPaper } = data || {}
  const onAction = (id, cmd) => {
    switch (cmd) {
      case "START":
        navigate(`/paper/${id}/diag`)
        return
      case "VIEW":
        navigate(`/paper/${id}/result`)
        return
    }
  }
  const items = allPaper
    ? allPaper.map(
        (v) =>
          ({
            id: v.id,
            type: "diag",
            code: v.item,
            name: v.item.shortName,
            status: v.status,
          } as ItemProps)
      )
    : []
  return <MyPage items={items} onAction={onAction} />
}
